const STORAGE_KEY = "cmz_user_auth";

export function getDevtoolsAuthToken() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return parsed && parsed.token ? parsed.token : null;
  } catch (err) {
    console.error("Failed to read Dev IDE auth token:", err);
    return null;
  }
}

export async function downloadWithAuth(url, filename) {
  const token = getDevtoolsAuthToken();
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  const res = await fetch(url, {
    method: "GET",
    headers,
  });

  if (!res.ok) {
    let errorMessage = "Download failed";
    try {
      const data = await res.json();
      errorMessage = data?.error || errorMessage;
    } catch (_) {
      // ignore non-JSON error bodies
    }
    throw new Error(errorMessage);
  }

  const blob = await res.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  if (filename) {
    link.download = filename;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}
